import { render, staticRenderFns } from "./math-topic-page.vue?vue&type=template&id=897fa212&"
import script from "./math-topic-page.vue?vue&type=script&lang=js&"
export * from "./math-topic-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports